import React, { createContext, useEffect, useRef, useState } from 'react';
import api from '../services/api';

export const PagesContext = createContext({});

function PagesProvider({ children }) {
    const [buttons,setButtons] = useState([])
    const [pages,setPages] = useState([])
    const [showModalEditPage,setShowModalEditPage] = useState(false)
    const [animation,setAnimation] = useState(false)
    const [dataPage,setDataPage] = useState()
    const [showModalEditButton,setShowModalEditButton] = useState()
    const [buttonId,setButtonId] = useState()
    const [buttonName,setButtonName] = useState()
    const [buttonImage,setButtonImage] = useState()


    const getAllPages = async () => {
        const response = await api.get("pages/get/all/user")
        if(response.status == 200){
            setPages(response.data) 
            return
        }
        setPages()

    }
    const get = async (name) => {
        const response = await api.get(`/pages/get/${name}`)
        if(response.status == 200){
            setDataPage(response.data)
        }
    }
    const getPagesByName = async (name) => {
        if(name == ""){
            getAllPages()
        }
        const response = await api.get(`pages/name/${name}`)
        if(response.status == 200){
            setPages(response.data)
            return
        }
    }
    const getButtonsByName = async (name) => {
        if(name == ""){
            getAllButtons()
        }
        const response = await api.get(`pages/get/buttons/${name}`)
        if(response.status == 200){
            setButtons(response.data)
            return
        }
    }
    const getAllButtons = async () => {
        setAnimation(true)
        const response = await api.get("buttons/get/all")
        if(response.status == 200){
            setButtons(response.data)
            setAnimation(false)
        }else{
            setAnimation(false)
        }
  
        // setButtons()


    }
    const deleteButton = async (id) => {
        const response = await api.delete(`buttons/delete/${id}`)
        if(response.status == 200){
            window.location.href="/dashboard/button"
        }
    }
    const deletePage = async (id) => {
        const response = await api.delete(`pages/delete/${id}`)
        if(response.status == 200){
            window.location.href="/dashboard/pages"
        }
    }
    return (
        <PagesContext.Provider value={{
            buttons,
            getAllButtons,
            deleteButton,
            getAllPages,
            pages,
            showModalEditPage,
            setShowModalEditPage,
            animation,
            get,
            dataPage,
            setShowModalEditButton,
            showModalEditButton,
            setButtonId,
            buttonId,
            setButtonName,
            buttonName,
            setButtonImage,
            buttonImage,
            deletePage,
            getPagesByName,
            getButtonsByName
            }}>
            {children}
        </PagesContext.Provider>
    );
}

export default PagesProvider;
